import { atom } from "recoil";

export const documentUploadFilesState = atom({
  key: "documentUploadFilesState",
  default: [],
});
